import type { Column } from '@tanstack/react-table';
import type { HTMLAttributes } from 'react';

import type { DataTableSortProps } from './types';

export function getSortByToggleProps<T>(
	column: Column<T>,
	setSort: DataTableSortProps['setSort']
): HTMLAttributes<HTMLElement> {
	const canSort = column.getCanSort();

	if (!canSort) {
		return {};
	}

	const columnName = column.columnDef.meta?.name;
	return {
		title: columnName ? `Sort by ${columnName}` : undefined,

		style: {
			cursor: 'pointer',
		},

		onClick: () => {
			setSort?.({
				sort: column.id,
				sortDirection: column.getNextSortingOrder() || column.getFirstSortDir(),
			});
		},
	};
}
